import styled from "styled-components"

const KioskBackground = styled.div`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #000;
`

export default KioskBackground



// WEBPACK FOOTER //
// ./src/Kiosk/KioskBackground.js